import Vue from "vue";
import Vuex from "vuex";
import { dataModule } from "./store-modules/dataModule";
import { httpModule } from "./store-modules/httpModule";
import { userModule } from "./store-modules/userModule";
import { routerModule } from "./store-modules/routerModule";
import { renderModule } from "./store-modules/renderModule";
import { paymentModule } from "./store-modules/paymentModule";
import { surveyModule } from "./store-modules/surveyModule";
import { studyResultsModule } from "./store-modules/studyResultsModule";
import { i18nModule } from "./store-modules/i18nModule";
import { ideaCoachModule } from "./store-modules/ideaCoachModule";
import {
  INIT_STORE,
  INIT_DATA_MODULE,
  INIT_USER_MODULE,
  INIT_PAYMENT_MODULE,
  A_PER_ROUTE_ACTIONS,
  A_DATA_MODULE_PER_ROUTE_ACTIONS,
  A_ROUTER_MODULE_PER_ROUTE_ACTIONS,
  A_STORE_RESULTS_MODULE_PER_ROUTE_ACTIONS,
  LOAD_SESSION_FROM_COOKIE,
  PRE_INIT_STORE,
  INIT_AUTHENTICATED_STORE,
  INIT_AUTHENTICATED_USER_MODULE,
  GET_IS_LOGGED_IN,
} from "./services/constants";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dataModule,
    httpModule,
    userModule,
    routerModule,
    renderModule,
    paymentModule,
    studyResultsModule,
    surveyModule,
    i18nModule,
    ideaCoachModule,
  },
  state: {},
  mutations: {},
  actions: {
    [PRE_INIT_STORE]: (context) => {
      return Promise.all([context.dispatch(LOAD_SESSION_FROM_COOKIE)]);
    },
    [INIT_STORE]: (context) => {
      const actions = [];
      actions.push(context.dispatch(INIT_USER_MODULE));
      actions.push(context.dispatch(INIT_DATA_MODULE));
      actions.push(context.dispatch(INIT_PAYMENT_MODULE));
      if (context.getters[GET_IS_LOGGED_IN]) {
        actions.push(context.dispatch(INIT_AUTHENTICATED_STORE));
      }
      return Promise.all(actions);
    },
    [INIT_AUTHENTICATED_STORE]: (context) => {
      return Promise.all([context.dispatch(INIT_AUTHENTICATED_USER_MODULE)]);
    },
    [A_PER_ROUTE_ACTIONS]: (context, toRoute) => {
      return Promise.all([
        context.dispatch(A_ROUTER_MODULE_PER_ROUTE_ACTIONS, toRoute),
        context.dispatch(A_DATA_MODULE_PER_ROUTE_ACTIONS, toRoute),
        context.dispatch(A_STORE_RESULTS_MODULE_PER_ROUTE_ACTIONS, toRoute),
      ]);
    },
  },
});
